<template>
  <div class="start-game-view">
    <div class="col">
      <div class="benia" ref="benia">
        <div class="message-box" ref="messagebenia" id="messagebenia">
          <div class="top"></div>
          <div class="wrap">
            <h3 class="headline hide-mob">CZEŚć!</h3>
            <p ref="quote">
              Przed Tobą trzy misje:
              Pieniądze od podszewki, Bezpieczeństwo
              i Zarządzam Budżetem. Podejmij wyzwanie i zalicz
              grę w każdej misji. Zwycięzcy otrzymają <strong>Certyfikat Samodzielniaka.</strong>
            </p>
          </div>
          <div class="bottom"></div>
        </div>
      </div>
      <div class="ducks duck150"></div>
      <div class="benek" ref="benek">
        <div  v-if="showPreloadMessage" class="message-box start_message" ref="messagebenek_start">
          <div class="top"></div>
          <div class="wrap left">
            <p>
              WITAJ W MISJI SAMODZIELNOŚĆ! <br />KLIKNIJ START, ABY ROZPOCZĄĆ.
            </p>
          </div>
          <div class="bottom"></div>
        </div>
        <div class="message-box" ref="messagebenek" id="messagebenek">
          <div class="top"></div>
          <div class="wrap left">
            <p>
              Cześć! Jestem Benek, to Benia, a to Kaczka Podpowiadaczka. A Ty? Jak masz na imię?
              Wpisz je do okienka i kliknij <span>ZACZYNAMY.</span>
            </p>
          </div>
          <div class="bottom"></div>
        </div>
      </div>
      <div  class="col-claim">
        <div class="wrap">
          <div v-if="showPreloadMessage" class="preloadGameWrap">
            <button class="btn btn-green" id="startTheGame" @click="preloadGame()"><span id="pressStart">START</span></button>
          </div>
          <div class="game-order-mask"  v-if="showList" ref="gamelist" id="gamelist">
                <ul class="game-list">
                  <li class="game-list_item">
                    <i  ref="order1" class="icon game_one"></i>
                    <h3 ref="titme1"><span>Misja</span>Pieniądze od podszewki <span class="white">Bankosłówka</span></h3>
                  </li>
                  <li class="game-list_item">
                    <i  ref="order2" class="icon game_two"></i>
                    <h3 ref="titme2"><span>Misja</span>Bezpieczeństwo <span class="white">piny bez spiny</span></h3>
                  </li>
                  <li class="game-list_item">
                    <i ref="order3" class="icon game_tree"></i>
                    <h3 ref="titme3"><span>Misja</span>zarządzam budżetem <span class="white">wirtualny sklepik</span></h3>
                  </li>
                </ul>
            <ul class="game-list">
              <li></li>
            <li>
              <div class="action-bar">
                <button class="btn btn-green" @click="gotoForm()"><span id="goToForm">DALEJ</span></button>
              </div>
            </li>
              <li></li>
            </ul>

          </div>

          <div class="addNameForm active" ref="form" id="form">
            <h3 class="player-name-label" ref="name">Imię Gracza</h3>
              <div class="input-art"  ref="inputname" >
                <input autocomplete="off" type="text" class="input-block" v-model="player" id="name" placeholder="TWOJE IMIĘ">
                <span class="eror-message">{{validMessage}}</span>
              </div>
            <button v-if="!loader" ref="btn" id="letsGo" class="btn btn-green" @click="gameOn()"><span>ZACZYNAMY</span></button>
            <div class="loader" v-if="loader">
              <h3>Wczytywanie....</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import { TimelineLite } from 'gsap';
import { Howl, Howler } from "howler";

export default {
name: "OrganismGameStart",
  data () {
    return {
      player: null,
      validMessage: null,
      loader: false,
      showList:false,
      showPreloadMessage:true,
      userInteracted: false,
      gamenameGTM:'',
    }
  },
  props: {
    timeLimit:{
      type: Number,
    },
  },
  methods: {
    ...mapActions(['startGame', 'playerName','stopAudio','muteGame']),
    preloadGame() {
      this.muteGame(true)
      this.showList = true;
      this.showPreloadMessage = false;
      this.benia();
      this.interacted();
      this.$gtm.push({
        event: 'ms-gameevent',
        category: "Misja samodzielność",
        action: "Kliknięcie w button - START",
        label: "Start aplikacji",  //  gameType
      })
    },

    benia(){
      const timeline = new TimelineLite();
      const {messagebenia} = this.$refs
        timeline.to(messagebenia, {opacity: 1})
    },
    interacted: function () {
      this.userInteracted = true
      let sound = new Howl(
          {
            src: [require('@/assets/audio/intro/intro_benia.mp3')],
            preload: true,
            autoplay: false,
            onend: function ( ){
                  const timeline = new TimelineLite();
                  const messagebenia = document.getElementById('messagebenia');
                  const messagebenek = document.getElementById('messagebenek');
                  const gamelist = document.getElementById('gamelist');
                  const form = document.getElementById('form');
                  timeline
                      .to(messagebenia, {opacity: 0})
                      .to(gamelist, {opacity: 0})
                      .to(form, {opacity: 1, visibility:"visible"})
                      .to(messagebenek, {opacity: 1})

                  let soundBenek = new Howl({
                    src: [require('@/assets/audio/intro/intro_benek.mp3')]
                  });
                  soundBenek.play();
            }
          }
        );
      sound.play();
    },
    gotoForm(){
      this.stopAudio();
      const timeline = new TimelineLite();
      const messagebenia = document.getElementById('messagebenia');
      const messagebenek = document.getElementById('messagebenek');
      const gamelist = document.getElementById('gamelist');
      const form = document.getElementById('form');
      timeline
          .to(messagebenia, {opacity: 0})
          .to(gamelist, {opacity: 0})
          .to(form, {opacity: 1, visibility:"visible"})
          .to(messagebenek, {opacity: 1})
      let soundBenek = new Howl({
        src: [require('@/assets/audio/intro/intro_benek.mp3')]
      });
      soundBenek.play();
      this.$gtm.push({
        event: 'ms-gameevent',
        category: "Misja samodzielność",
        action: "Kliknięcie w button - DALEJ",
        label: "Prezentacja gier",  //  gameType
      })
    },
    benek() {
      const timeline = new TimelineLite();
      const {messagebenia, benia, benek, messagebenek, gamelist, form} = this.$refs
      if (window.innerWidth < 800) {
        timeline
            .to(benia, {opacity: 0})
            .to(gamelist, {opacity: 0})
            .to(benek, {opacity: 1})
            .to(form, {opacity: 1, visibility:"visible"})
            .to(messagebenek, {opacity: 1})

      } else {
        timeline
            .to(messagebenia, {opacity: 0})
            .to(benia, {opacity: 0})
            .to(gamelist, {opacity: 0})
            .to(benek, {opacity: 1})
            .to(messagebenek, {opacity: 1})
            .to(form, {opacity: 1})
      }

    },
    gameOn() {

      this.stopAudio();
      if (this.player) {
        this.playerName(this.player);
        let letsplayAudio = new Howl({
          src: [require('@/assets/audio/intro/gameOn.mp3')]
        });
        letsplayAudio.play();
        this.loader = true;
        this.startGame(1);
        this.$gtm.push({
          event: 'ms-gameevent',
          category: "Misja samodzielność",
          action: "Kliknięcie w button - ZACZYNAMY (Sukces)",
          label: "Wybór imienia",  //  gameType
        })

      } else {
        this.validMessage = "To pole jest wymagane!"
        let inputError = new Howl({
          src: [require('@/assets/audio/intro/wymagane_pole.mp3')]
        });
        this.$gtm.push({
          event: 'ms-gameevent',
          category: "Misja samodzielność",
          action: "Kliknięcie w button - ZACZYNAMY (Błąd)",
          label: "Wybór imienia",  //  gameType
        })
        inputError.play();
      }
    }
  },
}

</script>


